<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onItemSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search"
          name="search"
        />
        <app-select
          @input="onChangeFilter"
          v-model="filter_legal_entity"
          :options="legal_entity_options"
          :reduce="item => item.id"
          placeholder="Legal entity"
          class="select--300"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #h__responsible><div class="table-default__left">Responsible</div></template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'finance-fund-requests-detail-items', params: {id: row.id }}" class="table-default__link-border">
              Request - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">{{ dateFormat(row.date) }}</template>
        <template #responsible="{ row }"><div class="table-default__left">{{ row.responsible.full_name }}</div></template>
        <template #total_estimated_amount="{ row }">
          {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.total_estimated_amount) }} {{ row.currency.code }}
        </template>
        <template #amount_total="{ row }">
          {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_total) }} {{ row.currency.code }}
        </template>
        <template #paid="{ row }">
            <span
              class="status-tag"
              :style="{'backgroundColor': row.paid ? '#77b017' : '#e85c20'}"
            >
              {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_paid) }} {{ row.currency.code }}
            </span>
        </template>
        <template #efd="{ row }">
            <span
              class="status-tag"
              :style="{'backgroundColor': row.efd ? '#77b017' : '#e85c20'}"
            >
              {{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2}).format(row.amount_efd) }} {{ row.currency.code }}
            </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { format, parseISO } from 'date-fns'
import { getAdministrativeLegalEntities, getFinanceFundRequests } from '@/http'

export default {
  name: 'FinanceFundRequestsCompleted',
  data() {
    return {
      page_loaded: false,
      search: '',
      filter_legal_entity: null,
      legal_entity_options: [],
      table: {
        items: [],
        columns: ['id', 'date', 'legal_entity.name', 'responsible', 'business_unit.name', 'total_estimated_amount', 'amount_total', 'paid', 'efd'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'legal_entity.name': 'Legal entity',
            'responsible': 'Responsible',
            'business_unit.name': 'Business unit',
            'total_estimated_amount': 'Est. amount',
            'amount_total': 'Total',
            'paid': 'Paid',
            'efd': 'EFD',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
    getAdministrativeLegalEntities().then(response => { this.legal_entity_options = response.data })
  },
  methods: {
    fetchItems() {
      getFinanceFundRequests({
        page: this.pagination.page,
        page_size: 20,
        search: this.search,
        status: 'completed',
        legal_entity: this.search ? '' : this.filter_legal_entity,
      })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.page_loaded = true
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onChangeFilter() {
      this.search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    onItemSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>
